/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import {
  SELECT_SPONSOR,
  SELECT_SPONSOR_ERROR,
  USER_ALLOCATIONS_ERROR,
  UPDATE_SPONSOR_SELECTION,
  FETCHING_TENANT_COOKIE,
  FETCHED_TENANT_COOKIE,
  ERROR_FETCHING_TENANT_COOKIE,
  FETCHING_USER_DETAILS_PENDING,
  FETCHING_USER_DETAILS_SUCCESS,
  FETCHING_USER_DETAILS_FAIL
} from '../actions/actionTypes';

const sponsorState = {
  selectedSponsor: null,
  selectSponsorError: null,
  userAllocationsError: null,
  updatedSponsor: null,
  isFetching: false,
  tenantCookieError: null,
  fetchingUserDetails: false
};

const sponsorReducer = (state = sponsorState, action) => {
  switch (action.type) {
    case SELECT_SPONSOR:
      return Object.assign({}, state, {
        selectedSponsor: action.payload,
        selectSponsorError: null,
        userAllocationsError: null,
        updatedSponsor: null
      });
    case UPDATE_SPONSOR_SELECTION:
      return Object.assign({}, state, {
        updatedSponsor: action.payload,
        selectSponsorError: null,
        userAllocationsError: null
      });
    case SELECT_SPONSOR_ERROR:
      return Object.assign({}, state, { selectSponsorError: action.payload });
    case USER_ALLOCATIONS_ERROR:
      return Object.assign({}, state, { userAllocationsError: action.payload });
    case FETCHING_TENANT_COOKIE:
      return Object.assign({}, state, { isFetching: true });
    case FETCHED_TENANT_COOKIE:
      return Object.assign({}, state, { isFetching: false, tenantCookieError: null });
    case ERROR_FETCHING_TENANT_COOKIE:
      return Object.assign({}, state, { tenantCookieError: action.payload });
    case FETCHING_USER_DETAILS_PENDING:
      return Object.assign({}, state, { fetchingUserDetails: true });
    case FETCHING_USER_DETAILS_SUCCESS:
      return Object.assign({}, state, { fetchingUserDetails: false });
    case FETCHING_USER_DETAILS_FAIL:
      return Object.assign({}, state, { fetchingUserDetails: false });
    default:
      return state;
  }
};

export default sponsorReducer;
